<template>
  <div class="flex flex-wrap">
    <div class="w-full break-words flex items-center mb-3">
      <input ref="name"
             spellcheck="false"
             v-model="name"
             class="w-full px-1 border-1 bg-transparent"
             :class="editName ? 'text-input' : 'pointer-events-none'"
             @keypress.enter="rename"
             @blur="rename"
      />
    </div>
    <div class="w-full flex items-center">
      <div class="w-8 flex items-center justify-center">
        <icon class="text-md" icon="terminal"/>
      </div>
      <input class="py-1 px-2 border-0 rounded w-full bg-gray-800 text-green-400 mx-1"
             v-model="content"
             ref="command"
      />
      <div class="w-12 text-gray-500 cursor-pointer flex flex-wrap justify-center hover:text-white"
           v-clipboard:copy="content"
           v-clipboard:success="onCopy"
           v-clipboard:error="onCopyError"
           :class="{'text-green-500': hasCopySuccess, 'text-red-500': hasCopyError}"
           v-if="content !== ''"
      >
        <icon class="w-full text-sm" icon="clone"/>
        <span class="w-full text-center text-xs">{{copyMessage}}</span>
      </div>
    </div>
  </div>
</template>

<script>
import attributeMixin from '@/mixins/attribute'
export default {
  mixins: [attributeMixin],
  props: ['attribute'],
  data () {
    return {
      content: this.attribute.value,
      name: this.attribute.name,
      copyMessage: 'copy',
      hasCopyError: false,
      hasCopySuccess: false
    }
  },
  methods: {
    onCopy () {
      this.copyMessage = 'copied!'
      this.hasCopySuccess = true
      setTimeout(() => {
        this.copyMessage = 'copy'
        this.hasCopySuccess = false
      }, 500)
    },
    onCopyError () {
      this.copyMessage = 'error'
      this.hasCopyError = true
      setTimeout(() => {
        this.copyMessage = 'copy'
        this.hasCopyError = false
      }, 500)
    }
  }
}
</script>

<style scoped lang="scss">
</style>
